import React, { useState } from 'react';

import Accordion from 'components/Accordion';
import Searcher from 'components/DesignSystem/Searcher';
import Snackbar from 'components/DesignSystem/Snackbar';
import useGroupedLocations from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useGroupedLocations';
import type Location from 'types/Locations/Location';

import GroupedLocations from './GroupedLocations';

export default function MultiLocation() {
  const {
    groupedMultiLocations,
    toggleMultiLocation,
    isLocationSelected,
    groupIdToName,
  } = useGroupedLocations();

  const [search, setSearch] = useState('');
  const pattern = new RegExp(search.split('').join('.*'), 'i');
  const filterLocations = (locs: Location[]) => locs.filter((l) => pattern.test(l.name));

  return (
    <Accordion.Item eventKey="multilocation" id="multilocation-accordion">
      <Accordion.Header>Locais</Accordion.Header>
      <Accordion.Body>
        <Searcher value={search} onChange={(e) => setSearch(e.target.value)} />
        {Object.keys(groupedMultiLocations).length === 0 && (
          <Snackbar className="mt-2">Nenhum grupo selecionado</Snackbar>
        )}
        {Object.entries(groupedMultiLocations).map(([groupId, locations]) => (
          <GroupedLocations
            key={groupId}
            groupName={groupIdToName[groupId]}
            locations={filterLocations(locations)}
            isLocationSelected={isLocationSelected}
            toggleLocation={toggleMultiLocation}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
